import React, { useEffect, useState, useRef } from 'react'
import WpAPI from '../../WpApi';
import { Redirect } from 'react-router';
import { 
  DASHBOARD_LINK, 
  POPUP_TYPES, 
  COOKIE_DOMAIN, 
  PAID_SERVICES, 
  MEMBERSHIP, 
  EDITOR_ALL_INONE_LINK, 
  COVERLETTER_CHOOSE_TEMPLATE,
  COVERLETTER_CUSTOMIZE,
  COVERLETTER_FINALIZE,
  COVERLETTER_EXPERIENCE,
} from '../../constants/constants';
import Cookie from 'js-cookie';
import { useDispatch } from 'react-redux';
import { 
  loadLetter, 
  saveLetter, 
  duplicateLetter as duplicateLetterAction, 
  PREVIEW_LETTER,
  userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction,
  setLetterFormat
} from '../../services/actions/actions';
import '../../assets/scss/app/blocks/dashboard.scss';
import downloadResume from '../../downloadResume';
import PageLoader from '../common/PageLoader';
import { usePopup } from '../../context/PopupContext';
import SignUpPopup from '../user/SignUpPopup';
import { useHistory, useLocation } from 'react-router-dom';
import Splash from '../common/Splash';
import { getDateForDisplay, getLetterName, removeBodyScroll } from '../../helper';
import { useUser } from '../../context/UserContext';
import LetterPreview from '../coverletter/templates/LetterPreview';

const CoverLettersListing = (props) => {
    const entityName = "Cover Letter";
    const entityType = "coverletter"
    const reactHistory = useHistory();
    const confirmbox = usePopup();
    const location = useLocation();
    const [entities, setEntities] = useState('')
    const [currentEntity, setCurrentEntity] = useState('');
    const [spinner, setSpinner] = useState(false)
    const [createAction, setCreateAction] = useState(false)
    const [editAction, setEditAction] = useState('')
    const [singleEntity, setSingleEntity] = useState('')
    const [renameEntity, setRenameEntityBox] = useState(false)
    const [newName, setNewName] = useState('')
    const [error, setError] = useState([])
    const [buttonList, setButtonList] = useState('');
    const entityRef = useRef("");
    const [entityLink, setEntityLink] = useState(false)
    const [showLoginPopUp, setShowLoginPopUp] = useState(false)
    const [loader, setLoader] = useState({download: false, save: false, share: false});
    const errorStyle = { color: 'red', fontSize: '10px' }
    const {
      checkMembership,
      plan,
      user
    } = useUser();
  
    const mounted = useRef(false);
  
    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    //set dashboard_tab
    useEffect(() => {
      Cookie.set('dashboard_tab', 'coverletter', {domain: COOKIE_DOMAIN, path: "/"});
    }, []);
  
    // Manage button list click on short size of template
  
    const dispatch = useDispatch()
    let entityNames = [];
  
    const editEntity = (key, editorType) => {
      dispatch(loadLetter(key)).then(res => { setEditAction(COVERLETTER_FINALIZE);
      })
  }
      
    const deleteEntity = key => {
      WpAPI.deleteLetter(key)
      let r = { ...entities }
      delete r[key]
      setEntities(r);
      setTimeout(() => {
        if (!Object.keys(r).length) {
          let loader = document.querySelector('.page-loader');
          if (loader != null) {
            loader.style.display = 'none';
          }
        }
      }, 200);
    }
  
    const duplicateEntity = key => {
      dispatch(duplicateLetterAction(key, '', 'list')).then(res => {
        let entities = JSON.parse(JSON.stringify(res))
        setEntities(entities);  
      })
    }  
    const onClickOutside = (e) => {
      if (e.target.classList.value != 'single-template')
        setButtonList('');
    }
    useEffect(() => {
      const handleClickOutside = (e) => {
        // If entity has been deleted then current reference is not found. So, we have to add a null condition.
        if ((entityRef.current && !entityRef.current.contains(e.target)) || entityRef.current == null) {
          onClickOutside && onClickOutside(e);
        }
      };
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }, [onClickOutside]);
  
    useEffect(() => {
      confirmbox.configurePopup(POPUP_TYPES);
    }, []);
  
    useEffect(() => {
      if (entities === '') {//Only for first time or till no entity is set
        WpAPI.loadCoverLettersInDashboard(setEntities);
        setTimeout(() => {
          if (!Object.keys(entities).length) {
            let loader = document.querySelector('.page-loader');
            if (loader != null) {
              loader.style.display = 'none';
            }
          }
        }, 1500);
      }
      if (currentEntity === '') {
        let cl = WpAPI.getCurrentLetter();
        setCurrentEntity(cl);
      }
      // outside click functionality
  
    }, []);
  
    if (createAction) {
      history.pushState(null, DASHBOARD_LINK);
      return <Redirect to={COVERLETTER_EXPERIENCE} />
    }
    if (editAction.length) {
      history.pushState(null, DASHBOARD_LINK);
      return <Redirect to={editAction} />
    }
  
    const dashboardEntities = Object.keys(entities).sort((x, y) => {
      if (entities[x].hasOwnProperty('modified_date') && entities[y].hasOwnProperty('modified_date')) {
        return (new Date(entities[x].modified_date)).getTime() - (new Date(entities[y].modified_date)).getTime()
      } else if (entities[x].hasOwnProperty('modified_date') && !entities[y].hasOwnProperty('modified_date')) {
        return (new Date(entities[x].modified_date)).getTime() - (new Date('1947-01-01')).getTime()
      } else if (!entities[x].hasOwnProperty('modified_date') && entities[y].hasOwnProperty('modified_date')) {
        return (new Date('1947-01-01')).getTime() - (new Date(entities[y].modified_date)).getTime()
      } else if (entities[x].hasOwnProperty('created_date') && entities[y].hasOwnProperty('created_date')) {
        return (new Date(entities[x].created_date)).getTime() - (new Date(entities[y].created_date)).getTime()
      }
    }).reverse();
  
    const checkEntityCount = (entities) => {
      return Object.keys(entities).length;
    }
  
    // const downloadHandle = (entity, type) => {
    //   setSpinner(true);
    //   downloadResume(entity, () => {
    //     setSpinner(false);
    //     gaTrack('RT App', 'Dashboard', `Download ${entityName}`);
    //     ga4Track(`app_dashboard_download_${entityType}`, 'RT App', `Download ${entityName}`);
    //   }, 'pdf');
  
    // }
  
    const downloadHandler = (key, downloadFormat) => {
      downloadResume({[entityType]: {...entities[key], id: key}, user: props.user}, user, () => { 
        confirmbox.close('download');
      }, downloadFormat, {type: entityType, name: entityName });
    }
  
    // const userCompletesSectionsDownloadsPrintsOrShares = (entity) => {
    //   dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({...entity}, 'list')).then(res => {
    //     if(res.completed){
    //       const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
    //       const el = (
    //           PAID_SERVICES && plan == 'pro' 
    //           ? 'User completes sections: Downloads, Prints or Shares' 
    //           : 'Free user completes sections: tries to download, print, share'
    //       );
    //       ga4Track(ec, 'RT App', el)
    //     }
    //   })
    // }
  
    const download = (params) => {

      if(WpAPI.isLoggedIn()){
          localStorage.setItem(`${entityName}Name`, params.rname);
          confirmbox.show('download', null, (popupParams) => {
              downloadHandler(params.key, popupParams.downloadFormat);
              // userCompletesSectionsDownloadsPrintsOrShares(params.resume); 
              gaTrack('RT App', 'Dashboard', `Download ${entityName}`)
              ga4Track(`app_dashboard_download_${entityType}`, 'RT App', `Download ${entityName}`);
          }, {plan: plan, entity:{type: entityType, name: entityName }, referrer:'dashboard'});
        ga4Track(`app_my_${entityType}s_download`, 'RT App', `My ${entityName}s: Download`);
      }else{
        setShowLoginPopUp(true);
        Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
      }
    }
  
    const share = (params) => {
      if(WpAPI.isLoggedIn()){
        if(PAID_SERVICES){
          if(plan == 'pro'){
            confirmbox.show('share', null, () => {
              gaTrack('RT App', 'Dashboard', `Share ${entityName}`)
              ga4Track(`app_dashboard_share_${entityType}`, 'RT App', `Share ${entityName}`);
            }, {[entityType]: {...params.coverletter, id: params.key}, user: props.user, type: 'list', entity:{type: entityType, name: entityName } })
          }else{
            reactHistory.push(MEMBERSHIP)
          }
        }else{
            confirmbox.show('share', null, () => {
              gaTrack('RT App', 'Dashboard', `Share ${entityName}`)
              ga4Track(`app_dashboard_share_${entityType}`, 'RT App', `Share ${entityName}`);
            }, {[entityType]: {...params.coverletter, id: key}, user: props.user, type: 'list', entity:{type: entityType, name: entityName }})
        }
        ga4Track(`app_my_${entityType}s_share_a_link`, 'RT App', `My ${entityName}s: Share a Link`);
        // userCompletesSectionsDownloadsPrintsOrShares(params.resume);
      }else{
        setShowLoginPopUp(true);
        Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
      }
    }
  
    const checkMembershipAction = (callback = false, params = false) => {
      if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
      checkMembership(() => {
        if(typeof callback == 'function'){
          callback(params);
          if(mounted.current) setLoader({...loader, [callback.name]: false});
        }
      });
    }
  
    return (
      <>
        <div className="dashboard-container cover-container">
          <Splash />
          <div className="block">
          {spinner ? (
            <div className="spinner spinner-dashboard">
              <img
                className="loader-img"
                src="{`${APP_DOMAIN}/assets/images/spinner.svg`}"
                alt="loader"
              />
            </div>
          ) : (
            ""
          )}
            <div className="create-new-mobile" onClick={() => {
                //Clean local storage otherwise it might create problem with other workflow
                localStorage.removeItem('cl_color')
                localStorage.removeItem('cl_template')
                localStorage.removeItem('cl_custom_color')
                localStorage.removeItem('cl_builder')
                gaTrack('RT App', 'Dashboard', `Create a New ${entityName}`);
                ga4Track('app_dashboard_create_button_mobile', 'RT App', `Create a New ${entityName} Mobile`);
              setCreateAction(true);
            }}>
              <span>+ Start a New {entityName}</span>
            </div>
            {/* <h1>My {entityName}s</h1> */}
            {/* {(Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && props.user !== null) 
              && <p>Welcome back{props.user.firstname != '' ? `, ${props.user.firstname} ${props.user.lastname}` : ''}!</p>
            } */}
            <div className="small-size-templates">
              <ul className={dashboardEntities.length == 1 ? 'size-template-col-2' : ''}>
                <li className="create-new" onClick={() => {
                    gaTrack('RT App', 'Dashboard', `Create a New ${entityName}`);
                    ga4Track('app_dashboard_create_button', 'RT App', `Create a New ${entityName}`);
                  setCreateAction(true);
                }}>
                  <span>+ Start a New {entityName}</span>
                </li>
                {dashboardEntities.length ? dashboardEntities.map((key, index) => {
                      let entity = entities[key];
                      let rname = getLetterName(entity)
                          entityNames[key] = rname
                          if (entityNames.includes(rname)) {
                            //duplicate name found
                            rname = fullname + "_" + index;
                          }
                          return (
                            <li className="single-template" key={key} ref={entityRef}>
                                
                                <div className="resume-actions">
                                  <div className="toggle-action-list" onClick={() => { setButtonList(key) }}><span></span><span></span><span></span></div>
                                  <div className={buttonList == key ? 'buttons-list active-button-list' : 'buttons-list'}>
                                    <ul>
                                      <li onClick={() => {
                                        editEntity(key, entity.active_editor);
                                        gaTrack('RT App', 'Dashboard', `Edit ${entityName} Icon`)
                                        ga4Track(`app_dashboard_edit_${entityType}_icon`, 'RT App', `Edit ${entityName} Icon`);
                                      }}><span className="icon-edit-copy"></span> Edit {entityName}</li>
                                      <li onClick={() => checkMembershipAction(download, {[entityType]: entity, key: key, rname: rname})}>
                                        <span className="icon-file-text"></span> {loader.download ? 'Loading...' : 'Download'}
                                      </li>
                                        {(PAID_SERVICES && plan == 'pro') && <li onClick={() => { checkMembershipAction(share, {[entityType]: entity, key: key}) }}><span className="icon-link"></span> {loader.share ? 'Loading...' : 'Share a Link'}</li>}
                                      <li onClick={() => {
                                        duplicateEntity(key);
                                        gaTrack('RT App', 'Dashboard', `Duplicate ${entityName}`)
                                        ga4Track(`app_dashboard_duplicate_${entityType}`, 'RT App', `Duplicate ${entityName}`);
                                      }}><span className="icon-copy"></span> Duplicate</li>
                                      <li onClick={(e) => {
                                          confirmbox.show('delete', null, () => {
                                            deleteEntity(key);
                                            gaTrack('RT App', 'Dashboard', `Delete ${entityName}`);
                                            ga4Track(`app_dashboard_delete_${entityType}`, 'RT App', `Delete ${entityName}`);
                                          })
                                      }}><span className="icon-trash"></span> Delete {entityName}</li>
                                    </ul>
                                  </div>
                                </div>
                                
                            <div className="resume-block">
                                <div className="static-view"
                                onClick={() => {
                                  editEntity(key, entity.active_editor);
                                  gaTrack('RT App', 'Dashboard', `Edit ${entityName}`);
                                  ga4Track(`app_dashboard_edit_${entityType}`, 'RT App', `Edit ${entityName}`);
                                }} role="button">
                                <LetterPreview data={entity} />
                              </div>
                          </div>
                          <div className="short-desc">
                              <div className="details">
                                <i title={rname}>{rname}</i>
                                  <span className="edit-date">Last Modified {getDateForDisplay(entity.modified_date)}</span>
                              </div>
                            </div>


                            </li>
                          );
                  }) : <PageLoader />}
              </ul>
            </div>
            {/* {showAiBanner ? <AiBanner setShowAiBanner={setShowAiBanner} showAiBanner={showAiBanner} /> : ''} */}
          </div>
        </div>
        {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} setEntities={r => setEntities(r)} /> : ''}
      </>
    );
}
export default CoverLettersListing